import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { BrandingProvider } from "@/context/BrandingContext";
import HomePage from "@/pages/HomePage";
import ApplyPage from "@/pages/ApplyPage";
import ApplySuccessPage from "@/pages/ApplySuccessPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminLayout from "@/pages/AdminLayout";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import AdminCandidatesPage from "@/pages/AdminCandidatesPage";
import AdminCandidateDetailPage from "@/pages/AdminCandidateDetailPage";
import AdminIntakesPage from "@/pages/AdminIntakesPage";
import AdminBrandingPage from "@/pages/AdminBrandingPage";
import AdminUsersPage from "@/pages/AdminUsersPage";
import RequireSuperAdmin from "@/components/RequireSuperAdmin";

const TOAST_OPTIONS = {
  style: {
    border: "2px solid #0C0C0C",
    borderRadius: 0,
    background: "#F5F3EE",
    color: "#0C0C0C",
    boxShadow: "4px 4px 0 0 #0C0C0C",
    fontFamily: "General Sans, sans-serif",
  },
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrandingProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/apply" element={<ApplyPage />} />
              <Route path="/apply/success" element={<ApplySuccessPage />} />
              <Route path="/apply/:slug" element={<ApplyPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboardPage />} />
                <Route
                  path="branding"
                  element={
                    <RequireSuperAdmin>
                      <AdminBrandingPage />
                    </RequireSuperAdmin>
                  }
                />
                <Route
                  path="intakes"
                  element={
                    <RequireSuperAdmin>
                      <AdminIntakesPage />
                    </RequireSuperAdmin>
                  }
                />
                <Route
                  path="users"
                  element={
                    <RequireSuperAdmin>
                      <AdminUsersPage />
                    </RequireSuperAdmin>
                  }
                />
                <Route path="candidates" element={<AdminCandidatesPage />} />
                <Route path="candidates/:id" element={<AdminCandidateDetailPage />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" toastOptions={TOAST_OPTIONS} />
        </BrandingProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
